import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, X } from 'lucide-react';
import msbLogo from '../assets/bank/msb.png';
import ocbLogo from '../assets/bank/ocb.png';
import pvbankLogo from '../assets/bank/pvbank.png';
import tpbankLogo from '../assets/bank/tp.png';
import techcombankLogo from '../assets/bank/tech.png';
import ncbLogo from '../assets/bank/ncb.png';

// Import logos for other banks - Make sure to add these PNG files to src/assets/bank/
try {
  var vietcombankLogo = require('../assets/bank/vietcombank.png');
} catch (e) { var vietcombankLogo = null; }
try {
  var seabankLogo = require('../assets/bank/sea.png');
} catch (e) { var seabankLogo = null; }
try {
  var sacombankLogo = require('../assets/bank/sacombank.png');
} catch (e) { var sacombankLogo = null; }
try {
  var vpbankLogo = require('../assets/bank/vp.png');
} catch (e) { var vpbankLogo = null; }
try {
  var vietinbankLogo = require('../assets/bank/viettinbank.png');
} catch (e) { var vietinbankLogo = null; }

const BankRegistrationPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('new'); // 'new' or 'registered'
  const [selectedBank, setSelectedBank] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [formData, setFormData] = useState({
    accountHolderName: '',
    accountNumber: '',
    cardNumber: '',
    ccv: '',
    expiryDate: ''
  });

  const featuredBanks = [
    { name: 'MSB', color: '#E31E24', logo: msbLogo },
    { name: 'OCB', color: '#00843D', logo: ocbLogo },
    { name: 'PVcomBank', color: '#005BAA', logo: pvbankLogo },
    { name: 'TPBank', color: '#ED1C24', logo: tpbankLogo },
    { name: 'TechcomBank', color: '#E30613', logo: techcombankLogo },
    { name: 'NCB', color: '#003DA5', logo: ncbLogo },
  ];

  const allBanks = [
    { name: 'Vietcombank', color: '#007A33', logo: vietcombankLogo },
    { name: 'SeABank', color: '#D32F2F', logo: seabankLogo },
    { name: 'DongA Bank', color: '#FF6B00', logo: require('../assets/bank/donga.png') },
    { name: 'MB', color: '#D71920', logo: require('../assets/bank/mb.png') },
    { name: 'Sacombank', color: '#1E4D9B', logo: sacombankLogo },
    { name: 'Ocean Bank', color: '#0066B3', logo: require('../assets/bank/ocean.png') },
    { name: 'BAC A BANK', color: '#003B71', logo: require('../assets/bank/baca.png') },
    { name: 'LienVietPostBank', color: '#F37021', logo: require('../assets/bank/lienvietpost.png') },
    { name: 'VPBank', color: '#009345', logo: vpbankLogo },
    { name: 'Agribank', color: '#007B3A', logo: require('../assets/bank/agribank.png') },
    { name: 'BaoViet Bank', color: '#0066B3', logo: require('../assets/bank/baoviet.png') },
    { name: 'BIDV', color: '#004B9B', logo: require('../assets/bank/bidv.png') },
    { name: 'VietinBank', color: '#0066A4', logo: vietinbankLogo },
    { name: 'ACB', color: '#0066B3', logo: require('../assets/bank/acb.png') },
    { name: 'HSBC', color: '#DB0011', logo: require('../assets/bank/hsbc.png') },
    { name: 'ASBank', color: '#00539B', logo: require('../assets/bank/asbank.png') },
    { name: 'Eximbank', color: '#003DA5', logo: require('../assets/bank/eximbank.png') },
    { name: 'Citibank', color: '#003DA5', logo: require('../assets/bank/citibank.png') },
    { name: 'GPBank', color: '#0066B3', logo: require('../assets/bank/gpbank.png') },
    { name: 'CB', color: '#003DA5', logo: require('../assets/bank/cb.png') },
    { name: 'PG Bank', color: '#FF6B00', logo: require('../assets/bank/pg.png') },
  ];

  const handleBankClick = (bank) => {
    setSelectedBank(bank);
    setFormData({
      accountHolderName: '',
      accountNumber: '',
      cardNumber: '',
      ccv: '',
      expiryDate: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Show success message
    setShowSuccessMessage(true);
    // Navigate to home after 2 seconds
    setTimeout(() => {
      navigate('/home');
    }, 2000);
  };

  const handleCloseModal = () => {
    setSelectedBank(null);
    setFormData({
      accountHolderName: '',
      accountNumber: '',
      cardNumber: '',
      ccv: '',
      expiryDate: ''
    });
  };

  return (
    <div className="min-h-screen bg-background" style={{ fontFamily: 'Arial' }}>
      {/* Header */}
      <header className="relative bg-gradient-primary">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2 w-12">
            <button
              onClick={() => navigate('/home')}
              className="p-2 rounded-lg text-primary-foreground hover:bg-white/10 transition-colors"
              aria-label="Quay lại"
            >
              <ArrowLeft className="h-8 w-8" />
            </button>
          </div>
          <div className="flex flex-col items-center">
            <h1 className="text-white text-[20px] font-bold">ĐĂNG KÝ NGÂN HÀNG</h1>
          </div>
          <div className="flex items-center gap-1 w-12 justify-end">
            <button
              onClick={() => navigate('/home')}
              className="p-2 rounded-lg text-primary-foreground hover:bg-white/10 transition-colors"
              aria-label="Trang chủ"
            >
              <Home className="h-8 w-8" />
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="relative min-h-screen bg-gray-900 pb-6">
        {/* Background Pattern - Dots */}
        <div
          className="absolute inset-0 z-0 pointer-events-none"
          style={{
            backgroundImage: 'radial-gradient(circle, rgba(251, 191, 36, 0.4) 2px, transparent 2px)',
            backgroundSize: '30px 30px',
            backgroundRepeat: 'repeat'
          }}
        />

        <div className="relative z-10">
          {/* Tabs */}
          <div className="flex gap-4 px-4 pt-4">
            <button
              onClick={() => setActiveTab('new')}
              className={`flex-1 py-3 rounded-lg font-bold text-[16px] transition-colors ${
                activeTab === 'new'
                  ? 'bg-primary text-white'
                  : 'bg-gray-700 text-white hover:bg-gray-600'
              }`}
            >
              Đăng ký mới
            </button>
            <button
              onClick={() => setActiveTab('registered')}
              className={`flex-1 py-3 rounded-lg font-bold text-[16px] transition-colors ${
                activeTab === 'registered'
                  ? 'bg-primary text-white'
                  : 'bg-gray-700 text-white hover:bg-gray-600'
              }`}
            >
              Đã đăng ký
            </button>
          </div>

          {/* Content */}
          <div className="px-4 mt-4">
            <div
              className="relative rounded-2xl p-5 shadow-lg overflow-hidden"
              style={{
                background: 'linear-gradient(135deg, #FAF0E6 0%, #F5E6D3 100%)'
              }}
            >
              {/* Background Pattern for content box */}
              <div
                className="absolute inset-0 z-0 pointer-events-none opacity-30"
                style={{
                  backgroundImage: `url(${require('../assets/trong-CK13KxDf.png')})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'repeat',
                  backgroundPosition: 'center'
                }}
              />

              <div className="relative z-10">
                {/* Featured Banks Section */}
                <div className="mb-6">
                  <h2 className="text-[20px] font-bold text-primary mb-3">
                    Đề xuất cao
                  </h2>
                  <div className="border-[3px] border-primary rounded-xl p-4">
                    <div className="grid grid-cols-3 gap-3">
                      {featuredBanks.map((bank, index) => (
                        <button
                          key={index}
                          onClick={() => handleBankClick(bank)}
                          className="bg-transparent p-3   flex items-center justify-center min-h-[70px]"
                        >
                          {bank.logo ? (
                            <img 
                              src={bank.logo} 
                              alt={bank.name}
                              className="w-full h-auto max-h-[50px] object-contain"
                            />
                          ) : (
                            <span className="text-[13px] font-bold" style={{ color: bank.color }}>
                              {bank.name}
                            </span>
                          )}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* All Banks Grid */}
                <div className="grid grid-cols-3 gap-3">
                  {allBanks.map((bank, index) => (
                    <button
                      key={index}
                      onClick={() => handleBankClick(bank)}
                      className="bg-transparent p-3  hover:shadow-md transition-shadow flex items-center justify-center min-h-[70px]"
                    >
                      {bank.logo ? (
                        <img 
                          src={bank.logo} 
                          alt={bank.name}
                          className="w-full h-auto max-h-[50px] object-contain"
                        />
                      ) : (
                        <span className="text-[12px] font-bold text-center leading-tight" style={{ color: bank.color }}>
                          {bank.name}
                        </span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bank Registration Modal */}
      {selectedBank && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="sticky top-0 bg-gradient-primary p-4 rounded-t-2xl flex items-center justify-between">
              <h2 className="text-white text-[18px] font-bold">
                ĐĂNG KÝ {selectedBank.name.toUpperCase()}
              </h2>
              <button
                onClick={handleCloseModal}
                className="text-white hover:bg-white/10 rounded-lg p-1 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            {/* Bank Logo */}
            <div className="flex items-center justify-center py-6 bg-gray-50">
              {selectedBank.logo ? (
                <img
                  src={selectedBank.logo}
                  alt={selectedBank.name}
                  className="h-16 object-contain"
                />
              ) : (
                <span className="text-[24px] font-bold" style={{ color: selectedBank.color }}>
                  {selectedBank.name}
                </span>
              )}
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label className="block text-gray-700 font-bold mb-2 text-[14px]">
                  Họ và tên chủ tài khoản <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="accountHolderName"
                  value={formData.accountHolderName}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none text-[14px]"
                  placeholder="Nhập họ và tên"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-bold mb-2 text-[14px]">
                  Số tài khoản NH <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="accountNumber"
                  value={formData.accountNumber}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none text-[14px]"
                  placeholder="Nhập số tài khoản"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-bold mb-2 text-[14px]">
                  Số thẻ <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="cardNumber"
                  value={formData.cardNumber}
                  onChange={handleInputChange}
                  required
                  maxLength="16"
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none text-[14px]"
                  placeholder="Nhập số thẻ"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 font-bold mb-2 text-[14px]">
                    CCV <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="ccv"
                    value={formData.ccv}
                    onChange={handleInputChange}
                    required
                    maxLength="3"
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none text-[14px]"
                    placeholder="CCV"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-bold mb-2 text-[14px]">
                    Ngày hết hạn <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="expiryDate"
                    value={formData.expiryDate}
                    onChange={handleInputChange}
                    required
                    placeholder="MM/YY"
                    maxLength="5"
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-primary focus:outline-none text-[14px]"
                  />
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-primary hover:bg-primary/90 text-white font-bold py-3 rounded-lg transition-colors text-[16px] mt-6"
              >
                KÊ KHAI
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Success Message */}
      {showSuccessMessage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center">
            <div className="mb-4 flex justify-center">
              <div className="bg-green-100 rounded-full p-4">
                <svg className="w-16 h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <h3 className="text-[20px] font-bold text-gray-800 mb-2">Thành công!</h3>
            <p className="text-[16px] text-gray-600">Bạn đã kê khai thành công</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BankRegistrationPage;
 